<template>
  <!-- 新闻中心 -->
  <div class="newsCenter">
    <!-- 头部 -->
    <headerNav activeIndex="newsCenter" @setBanner="setBanner"  @getUrl="getUrl"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc" style="padding: 0 72px 148px" id="mainNav">
      <div class="maxWidth mainNav" ref="mainNav">
        <!-- 目录 -->
        <div class="mainIndex" :style="show ? 'z-index:-1' : ''">
          <ul
            id="aboutUsIndex"
            :style="show ? 'opacity:0;' : ''"
            style="position: relative"
          >
            <div
              :style="`position:absolute;top:${top}px;right:55px;width:74px;height:2px;background:#3f6b33;transition: all 0.5s;`"
            ></div>
            <li class="title Regular">新闻中心</li>
            <li class="index">
              <span
                :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav(1)"
                >公司新闻</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav(2)"
                >行业动态</span
              >
            </li>
          </ul>
        </div>
        <!-- 浮动目录 -->
        <div
          class="mainIndex"
          :style="show ? '' : 'z-index:-1'"
          style="position: fixed; top: 160px"
        >
          <ul
            id="aboutUsIndex"
            style="position: relative"
            :style="show ? '' : 'opacity:0;z-index:-1'"
          >
            <div
              :style="`position:absolute;top:${top}px;right:55px;width:74px;height:2px;background:#3f6b33;transition: all 0.5s;`"
            ></div>
            <li class="title Regular">新闻中心</li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav(1)"
                >公司新闻</span
              >
            </li>
            <li class="index">
              <span
                class=""
                :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                @click="goNav(2)"
                >行业动态</span
              >
            </li>
          </ul>
        </div>
        <!-- 右侧内容 -->
        <div
          class="mainContent"
          style="border-left: 1px solid #719468; padding-left: 55px"
        >
          <div
            style="
              border-bottom: 1px solid #719468;
              padding: 14px 0;
              line-height: 23px;
              display: flex;
              align-items:center;
            "
          >
            <div style="font-size: 18px" class="clickBtn1" @click="goHome">
              <i class="el-icon-location" style="color:#3f6b33;"></i> 首页
            </div>
            <div style="font-size: 18px; margin: 0 5px;flex:1;">- 新闻中心</div>
            <div>
              <el-input
                placeholder="请检索新闻内容"
                v-model="searchValue"
                @keyup.enter.native="getNewsList"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getNewsList"
                  style="cursor: pointer"
                ></i>
              </el-input>
            </div>
          </div>
          <div
            style="padding: 44px 20px"
            :style="
              type === 2
                ? `margin-top:20px;background:rgba(238, 238, 238, 0.3);`
                : ''
            "
          >
            <div v-if="type === 1">
              <el-skeleton :loading="companyNewsList.length === 0" animated>
                <template slot="template">
                  <div
                    v-for="(item, index) of 2"
                    :key="index"
                    class="newsList"
                    style=""
                  >
                    <div style="width: 375px; margin-right: 37px">
                      <el-skeleton-item
                        variant="image"
                        style="width: 375px; height: 200px"
                      />
                    </div>
                    <div style="flex: 1">
                      <div
                        style="
                          margin-bottom: 27px;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <div class="title" style="font-size: 20px; flex: 1">
                          <el-skeleton-item variant="h3" />
                        </div>
                        <div style="color: #535353; font-size: 15px">
                          <el-skeleton-item variant="text" />
                        </div>
                      </div>
                      <div style="font-size: 15px; line-height: 27px">
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                      </div>
                    </div>
                  </div>
                </template>
                <template>
                  <div
                    v-for="(item, index) of companyNewsList"
                    :key="index"
                    class="newsList"
                    style=""
                    @click="goDetail(item.id)"
                  >
                    <div style="width: 375px; margin-right: 37px">
                      <img
                        :src="getUrlPrefix(item.images)"
                        style="
                          max-width: 100%;
                          max-height: 260px;
                          border: 1px solid #e5e5e5;
                        "
                        alt=""
                      />
                    </div>
                    <div style="flex: 1">
                      <div
                        style="
                          margin-bottom: 27px;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <div
                          class="title bold"
                          style="font-size: 20px; flex: 1; margin-right: 10px"
                          v-html="item.title"
                        >
                        </div>
                        <div style="color: #535353; font-size: 15px">
                          {{ item.releaseTime }}
                        </div>
                      </div>
                      <div
                        style="
                          font-size: 15px;
                          line-height: 27px;
                          color: #353535;
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 4;
                          overflow: hidden;
                        "
                        :title="item.description"
                        v-html="item.description"
                      >
                      </div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
              <pager
                :total="total"
                :pageSize="pageSize"
                :pageNum.sync="currentPage1"
                @goPage="goPage()"
              ></pager>
            </div>
            <div v-if="type === 2">
              <el-skeleton :loading="companyNewsList.length === 0" animated>
                <template slot="template">
                  <div
                    v-for="(item, index) of 2"
                    :key="index"
                    class="newsList"
                    style=""
                  >
                    <div style="width: 375px; margin-right: 37px">
                      <el-skeleton-item
                        variant="image"
                        style="width: 375px; height: 200px"
                      />
                    </div>
                    <div style="flex: 1">
                      <div
                        style="
                          margin-bottom: 27px;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <div class="title" style="font-size: 20px; flex: 1">
                          <el-skeleton-item variant="h3" />
                        </div>
                        <div style="color: #535353; font-size: 15px">
                          <el-skeleton-item variant="text" />
                        </div>
                      </div>
                      <div style="font-size: 15px; line-height: 27px">
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                        <el-skeleton-item variant="text" />
                      </div>
                    </div>
                  </div>
                </template>
                <template>
                  <div
                    v-for="(item,index) of companyNewsList"
                    :key="index"
                    class="newsList"
                    style=""
                    @click="goDetail(item.id)"
                  >
                    <div style="width: 375px; margin-right: 37px">
                      <img
                        :src="getUrlPrefix(item.images)"
                        style="width: 100%"
                        alt=""
                      />
                    </div>
                    <div style="flex: 1">
                      <div
                        style="
                          margin-bottom: 27px;
                          display: flex;
                          align-items: center;
                        "
                      >
                        <div
                          class="title bold"
                          style="font-size: 20px; flex: 1; margin-right: 10px"
                          v-html="item.title "
                        >
                          
                        </div>
                        <div style="color: #535353; font-size: 15px">
                          {{ item.releaseTime }}
                        </div>
                      </div>
                      <div
                        style="
                          font-size: 15px;
                          line-height: 27px;
                          color: #353535;
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 4;
                          overflow: hidden;
                        "
                        :title="item.description"
                        v-html="item.description"
                      >
                      </div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
              <pager
                :total="total"
                :pageSize="pageSize"
                :pageNum.sync="currentPage1"
                @goPage="goPage()"
              ></pager>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div>
        <div
          style="
            margin: 0 auto 0;
            padding: 0.38rem 0 0.2rem;
            text-align: center;
          "
        >
          <div style="font-size: 0.34rem;line-height:1.4;color:#ddd;font-weight: 400;font-family: 'Proxima-Bold', sans-serif;">NEWS CENTER</div>
          <div style="color:#0f3a3c;font-weight: 600;margin-top:-4px;" class="fzTitle">新闻中心</div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding: 0.2rem 0.2rem 0.26rem;
          "
        >
          <div
            style="
              flex: 1;
              text-align: center;
              font-size: 0.12rem;
              padding: 0.1rem 0;
              border-radius: 50px 0 0 50px;
            "
            :style="
              navIndex === 1
                ? 'background:#719468;color:#fff;'
                : 'background:#e5e5e5;'
            "
            @click="goNav(1)"
          >
            公司新闻
          </div>
          <div
            style="
              flex: 1;
              text-align: center;
              font-size: 0.12rem;
              padding: 0.1rem 0;
              border-radius: 0 50px 50px 0;
            "
            :style="
              navIndex === 2
                ? 'background:#719468;color:#fff;'
                : 'background:#e5e5e5;'
            "
            @click="goNav(2)"
          >
            行业新闻
          </div>
        </div>
        <div style="padding: 0 0.2rem 0.26rem">
          <el-skeleton :loading="companyNewsList.length === 0" animated>
            <template slot="template">
              <div
                v-for="(item, index) of 2"
                :key="index"
                class="newsList"
                style=""
              >
                <div style="width: 1.35rem; margin-right: 0.14rem">
                  <el-skeleton-item
                    variant="image"
                    style="width: 1.35rem; height: 0.81rem"
                  />
                </div>
                <div style="flex: 1">
                  <div
                    style="
                      margin-bottom: 0.1rem;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <div class="title" style="font-size: 0.13rem; flex: 1">
                      <el-skeleton-item variant="h3" />
                    </div>
                    <div style="color: #535353; font-size: 0.1rem">
                      <el-skeleton-item variant="text" />
                    </div>
                  </div>
                  <div style="font-size: 0.1rem">
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                    <el-skeleton-item variant="text" />
                  </div>
                </div>
              </div>
            </template>
            <template>
              <div
                v-for="(item, index) of companyNewsList"
                :key="index"
                class="newsList"
                style="border-bottom:1px solid #e5e5e5;padding-bottom:0.2rem;margin-bottom:0.2rem;"
                @click="goDetail(item.id)"
              >
                <div style="width: 1.6rem; margin-right: 0.1rem">
                  <img
                    :src="getUrlPrefix(item.images)"
                    style="max-width: 100%; border: 1px solid #e5e5e5"
                    alt=""
                  />
                </div>
                <div style="flex: 1">
                  <div
                    style="
                      margin-bottom: 0.1rem;
                      display: flex;
                    "
                  >
                    <div
                      class="title bold"
                      style="font-size: 0.16rem; flex: 1; margin-right: 0.05rem;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 2;
                      overflow: hidden;"
                    >
                      {{ item.title }}
                    </div>
                    <div style="color: #535353; font-size: 0.12rem;margin-top:0.03rem;">
                      {{ item.releaseTime }}
                    </div>
                  </div>
                  <div
                    style="
                      font-size: 0.12rem;
                      color: #353535;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 3;
                      overflow: hidden;
                    "
                    :title="item.description"
                  >
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </template>
          </el-skeleton>
          <div v-if="total === companyNewsList.length" style="font-size:0.12rem;text-align:center;color:#666;">
            下拉到底部了
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import $ from 'jquery'
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { getNewsList, findNewsById } from '@/api/news'
import { updateReadingVolume } from '@/api/common'
export default {
  name: 'newsCenter',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: '',
      }, //轮播图
      show: false,
      mobile: false,
      navIndex: 1,
      brandProfileNavShow: false,
      top: 100,
      numShow: false,
      currentPage1: 1,
      pageSize: 10,
      type: 1,
      total: 0,
      companyNewsList: [], //公司新闻数据集合
      industryNewsList: [], //行业动态数据集合
      newsDetail: {}, //新闻详情
      searchValue:"",//检索内容
    }
  },
  mounted() {
    this.mobile = this.isMobile()
    if (this.mobile === true) {
      this.pageSize = 100
      
    }else{
      window.addEventListener('scroll', this.getScroll)
    }
    if(this.isMobile() === true){
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '新闻中心',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
    if (window.location.hash !== '') {
      var name = window.location.hash.replace('#', '')
      if (name === 'enterprise') {
        this.navIndex = 1
        this.type = 1
        this.top = 96
      } else {
        this.navIndex = 2
        this.type = 2
        this.top = 153
      }
    }
    this.getNewsList()
    if (this.$route.params.id) {
      this.goDetail(this.$route.params.id)
    }
  },
  methods: {
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    getScroll() {
      var aboutUsIndex = document.getElementById('mainNav').offsetTop
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.mobile === false) {
        this.show = aboutUsIndex - 200 < scrollTop
      }
    },
    goNav(name) {
      var a = document.getElementById('mainNav').offsetTop
      $('body,html').animate({ scrollTop: a - 200 }, 200)
      if (this.navIndex === name) {
        return
      }
      this.navIndex = name
      this.searchValue = ""
      this.getNewsList()
      if (name === 1) {
        this.type = 1
        this.top = 96
      } else {
        this.type = 2
        this.top = 153
      }
    },
    goPage() {
      // this.$refs.mainNav.scrollIntoView({
      //   behavior: "smooth",
      //   block: "top",
      // });
      var a = document.getElementById('mainNav').offsetTop
      $('body,html').animate({ scrollTop: a - 200 }, 200)
      //公司新闻
      var form = {
        type: this.navIndex,
        pageSize: this.pageSize,
        pageNum: this.currentPage1,
        title:this.searchValue
      }
      getNewsList(form).then((response) => {
        
        var dataList = response.data.list
        if(this.searchValue !== ""){
          dataList.forEach(item => {
            var reg = this.searchValue;
            item.title = item.title.replace(
              reg,
              `<b style='color:red;'>${reg}</b>`
            );
            item.description = item.description.replace( 
              reg,
              `<b style='color:red;'>${reg}</b>`
            );
          });
        }
        this.companyNewsList = dataList
        this.total = response.data.total
      })
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
    goDetail(id) {
      this.$router.push({name:'newsDetail',params:{id:id}})
    },
    getNewsList() {
      this.currentPage1 = 1
      this.companyNewsList = []
      //公司新闻
      var form = {
        type: this.navIndex,
        pageSize: this.pageSize,
        pageNum: this.currentPage1,
        title:this.searchValue
      }
      getNewsList(form).then((response) => {
        var dataList = response.data.list
        if(this.searchValue !== ""){
          dataList.forEach(item => {
            var reg = this.searchValue;
            item.title = item.title.replace(
              reg,
              `<b style='color:red;'>${reg}</b>`
            );
            item.description = item.description.replace( 
              reg,
              `<b style='color:red;'>${reg}</b>`
            );
          });
        }
        this.companyNewsList = dataList
        this.total = response.data.total
      })
    },
    getUrl(val){
      var name = val.replace('#', '')
      if (name === 'enterprise') {
        this.navIndex = 1
        this.type = 1
        this.top = 96
      } else {
        this.navIndex = 2
        this.type = 2
        this.top = 153
      }
      this.getNewsList()
    }
  },
}
</script>

<style lang="scss">
.newsCenter {
  .newsList {
    display: flex;
    align-items: center;
    margin-bottom: 67px;
    cursor: pointer;
    img {
      transition: all 0.5s;
    }
  }
  .newsList:hover {
    .title {
      color: #719468;
    }
    img {
      transform: scale(1.1);
    }
  }
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .mainIndex {
    width: 217px;
  }
  .mainContent {
    flex: 1;
  }
  .mainNav {
    position: relative;
    margin-top: 98px;
    display: flex;
  }
  .brandProfileNav {
    position: relative;
  }
  .mainIndex {
    text-align: right;
    ul {
      padding: 8px 55px 8px 0;
    }
    .title {
      color: #1b1b1b;
      font-size: 27px;
      line-height: 27px;
      margin-bottom: 32px;
    }
    .index {
      color: #707070;
      font-size: 18px;
      line-height: 27px;
      margin-bottom: 30px;
    }
    .index:last-child {
      margin-bottom: 0;
    }
  }
  .clickBtn2 {
    cursor: pointer;
  }
  .selectBtn {
    color: #3f6b33;
    cursor: pointer;
    position: relative;
  }
  .selectBtn1::after {
    content: '';
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: -10px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/newsCenter/index.vue